import { Skeleton } from "@/components/ui/skeleton";

const OrgRowSkeleton = () => (
  <div className="flex items-center gap-2 border-b border-border px-3 py-2.5">
    <Skeleton className="h-5 w-5 rounded" />
    <Skeleton className="h-7 w-7 rounded-full" />
    <div className="flex-1 space-y-1">
      <Skeleton className="h-4 w-36" />
      <Skeleton className="h-3 w-16" />
    </div>
    <Skeleton className="h-9 w-40" />
    <Skeleton className="h-9 w-40" />
  </div>
);

const OrgListSkeleton = () => (
  <div className="space-y-0">
    {Array.from({ length: 5 }).map((_, i) => (
      <OrgRowSkeleton key={i} />
    ))}
  </div>
);

export default OrgListSkeleton;
